export default __webpack_public_path__ + "static/media/image_3.bea3e45f.jpg";